export class UnlockConnectorRequest{
    chargePointEvseId: number;
    reason: string;
}